import React from 'react';
import { NavItem, Nav } from 'react-bootstrap';

import FlexibleInput from './FlexibleInput.js';

export default class SearchView extends React.Component {

  constructor(props) {
    super(props);
    var state = {
      config: props.config,
      selected: 0,
      object: {},
    };
    Object.keys(state.config).forEach((key) => {
      var type = state.config[key].type;
      if (props.defaultValue) {
        var defaultValue = props.defaultValue[key];
        if (typeof defaultValue === "string" && type === "select") {
          state.object[key] = {
            value: {
              id: defaultValue,
              name: defaultValue,
              value: defaultValue,
              label: defaultValue,
            }
          };
          return;
        }
        if (typeof defaultValue === "object") {
          state.object[key] = {
            value: defaultValue
          };
          return;
        }
      }
      if (type === "text") {
        state.object[key] = {
          value: ""
        }
      }
      if (type === "address") {
        var addressKeys = Object.keys(state.config[key].placeholder);
        state.object[key] = {value: {}}
        for (let j = 0; j < addressKeys.length; j++) {
          state.object[key].value[addressKeys[j]] = "";
        }
      }
      if (type === "select") {
        state.object[key] = {
          options: [],
          value: null
        }
      }
      if (type === "multi") {
        state.object[key] = {
          options: [],
          value: []
        }
      }
      if (type === "date-interval") {
        var today = new Date();
        var monthBefore = new Date();
        monthBefore.setMonth(monthBefore.getMonth() - 1);
        state.object[key] = {
          value: {
            from: monthBefore.toISOString(),
            to: today.toISOString()
          }
        }
      }
      if (type === "interval") {
        state.object[key] = {
          value: {
            from: "",
            to: ""
          }
        }
      }
      if (type === "scan") {
        state.object[key] = {
          value: []
        }
      }
    });
    this.state = state;
  }

  componentWillReceiveProps = (props) => {
    if (props.config !== this.state.config) {
      this.props = props;
      this.state = this.getInitialState();
    }
  }

  handleChange = (key, value) => {
    var object = this.state.object;
    object[key].value = value;
    this.setState({object: object});

    if (this.props.onChange) {
      var search = {};
      var keys = Object.keys(this.state.object);
      for (let i = 0; i < keys.length; i++) {
        search[keys[i]] = this.state.object[keys[i]].value;
      }
      this.props.onChange(search);
    }
  }

  handleKeyUp = (e) => {
    if (e.keyCode === 13) {
      let key = Object.keys(this.state.object)[this.state.selected];
      if (this.state.config[key].type !== "scan") {
        this.handleSearchClick(e);
      }
    }
  }

  handleSearchClick = (e) => {
    var search = {};
    var keys = Object.keys(this.state.object);
    for (let i = 0; i < keys.length; i++) {
      search[keys[i]] = this.state.object[keys[i]].value;
    }
    this.props.onSearch(search);
  }

  handleSwitch = (e) => {
    this.setState({selected: (e - 1)});
  }

  render = () => {
    const keys = Object.keys(this.state.object).filter(key => {
      const adminGroup = !!((this.props.user || {}).user_group || {}).admin;
      if (this.state.config[key].adminGroup && !adminGroup) {
        return false;
      }
      return true;
    });
    const searchBars = keys.map((key, i) => {
      return (
        <div
          key={key}
          className={i === this.state.selected ? `search-${this.state.config[key].type}` : "hidden"}
        >
          <FlexibleInput
            object={this.state.object[key].value}
            onChange={this.handleChange}
            objectKey={key}
            objectProperties={this.state.config}
          />
        </div>
      )
    });

    const searchNav = keys.map((key, index) => {
      return (
        <NavItem 
          eventKey={index + 1}
          key={key}
        >{this.state.config[key].title}</NavItem>
      )
    });
    let searchButton = null;
    if (this.props.onSearch) {
      searchButton = <input 
        type="button"
        onClick={this.handleSearchClick}
        value="Поиск"
        className="btn button-search"
      />
    }
    return (
      <div className="search-view" onKeyUp={this.handleKeyUp}>
        <Nav bsStyle="tabs" activeKey={this.state.selected + 1} onSelect={this.handleSwitch}>
          {searchNav}
        </Nav>
        {searchBars}
        {searchButton}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/SearchView.js